import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _uniqueId from 'lodash/uniqueId';
import React, { useState } from 'react';
import styles from './ImageCard.scss';
export var ImageCardBase = function ImageCardBase(props) {
  var Element = props.href ? 'a' : 'button';

  var _useState = useState(_uniqueId('imagecard-')),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();

      if (props.onClick) {
        props.onClick();
      }

      if (props.href) {
        window.location.href = props.href;
      }
    }
  };

  return React.createElement(Element, {
    "aria-label": props.title,
    "aria-describedby": props.category ? "".concat(id, "-category ").concat(id) : id,
    className: styles.basicCard,
    href: props.href,
    tabIndex: 0,
    "data-test": props.dataTest,
    onClick: props.onClick,
    onFocus: props.onFocus,
    onMouseOver: props.onHover,
    onKeyPress: handleKeyPress
  }, React.createElement("div", {
    className: styles.imageView
  }, React.createElement("div", {
    className: styles.imageText
  }, props.category && React.createElement("div", {
    className: styles.category,
    "data-test": "category",
    id: "".concat(id, "-category")
  }, props.category), React.createElement("div", {
    className: styles.title,
    "data-test": "title",
    id: "".concat(id, "-title")
  }, props.title), props.children && React.createElement("div", {
    "data-test": "content",
    id: id
  }, props.children)), props.imageSrc && React.createElement("div", {
    className: styles.image,
    style: {
      maxHeight: props.maxHeight ? props.maxHeight : 'auto'
    },
    "data-test": "image-frame"
  }, React.createElement("img", {
    className: styles.imageElement,
    src: props.imageSrc,
    alt: "",
    "data-test": "image"
  })), props.illustration && React.createElement("div", {
    className: styles.image,
    "data-test": "image-frame"
  }, props.illustration)));
};